import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/react';

const slotSpin = keyframes`
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(calc(var(--reel-offset) * -1.2em));
  }
`;

export const SlotMachine = styled.span`
  display: inline-flex;
  align-items: center;
  height: 1.2em;
  vertical-align: baseline;
`;

export const StaticValue = styled.span`
  display: inline-block;
`;

export const Reel = styled.span`
  display: inline-block;
  height: 1.2em;
  overflow: hidden;
  line-height: 1.2;
`;

export const Strip = styled.span<{ $spinning?: boolean }>`
  display: flex;
  flex-direction: column;
  transform: translateY(0);
  will-change: transform;

  ${(p) =>
    p.$spinning &&
    css`
      animation: ${slotSpin} 1.05s cubic-bezier(0.12, 0.82, 0.22, 1) forwards;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    `}
`;

export const Digit = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.2em;
`;
